(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-carousel')) {
    class FeaturedCollectionCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-carousel-viewport]');
        if (!this.viewport) return;

        this.previousButton = document.querySelector(`[data-carousel-previous][aria-controls="${this.viewport.id}"]`);
        this.nextButton = document.querySelector(`[data-carousel-next][aria-controls="${this.viewport.id}"]`);
        this.controls = this.previousButton?.parentElement;
        if (!this.controls || !this.previousButton || !this.nextButton) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.previousButton.addEventListener('click', () => this.scrollByPage(-1), { signal });
        this.nextButton.addEventListener('click', () => this.scrollByPage(1), { signal });
        this.viewport.addEventListener('scroll', () => this.updateControls(), { signal, passive: true });
        this.viewport.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.viewport);
        this.updateControls();
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      scrollByPage(direction) {
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.viewport.scrollBy({ left: this.viewport.clientWidth * 0.9 * direction, behavior });
      }

      handleKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.scrollByPage(event.key === 'ArrowRight' ? 1 : -1);
      }

      updateControls() {
        const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const hasOverflow = maximumScroll > 1;
        this.controls.hidden = !hasOverflow;
        this.previousButton.disabled = !hasOverflow || this.viewport.scrollLeft <= 1;
        this.nextButton.disabled = !hasOverflow || this.viewport.scrollLeft >= maximumScroll - 1;
      }
    }

    customElements.define('featured-collection-carousel', FeaturedCollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
